import {useState} from "react";
import {
    CardActions,
    CardHeader,
    Button,
    Container,
    Card,
    CardContent,
    Typography,
    useTheme,
    Box,
    TextField,
    Backdrop, CircularProgress,
    Grid
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {tokens} from "../../theme.ts";
import { signIn } from "aws-amplify/auth";
import { useAuth } from "../../context/auth/useAuth";
import { Navigate } from "react-router-dom";

const SignInComponent = () => {
    const {t} = useTranslation();
    const { user } = useAuth();
    const [error, setError] = useState<boolean>(false);
    const navigate = useNavigate();
    const [errorMessage] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const theme = useTheme();
    const colors = tokens(theme.palette);
    const [loading, setLoading] = useState(false);

    if (user) {
        return <Navigate to="/" />;
    }

    const handleLogin = async () => {
        setLoading(true);
        try{
            await signIn({username, password});
            setLoading(false);
            navigate("/");
        }catch (e) {
            console.log("Login Error: ", e);
            setError(true);
        }
        setLoading(false);
    }

    return (
        <Container sx={{ display: 'flex', height: "100%", justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Box maxWidth={"xs"} sx={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}
                 onKeyDown={async (event) => {
                     if (event.key === "Enter") {
                         await handleLogin();
                     }
                 }}
            >
                <Card sx={{flex: 1, borderRadius: 4, p: 2, justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                    <CardHeader title={t("KMG-VISION.cloud Creator")} sx={{textAlign: 'center'}}/>
                    <CardContent>
                        <Grid container spacing={2}>
                                <Grid size={{xs: 12}}>
                                    <TextField
                                        error={error}
                                        sx={{background: "white"}}
                                        fullWidth
                                        variant="standard"
                                        label={t("signIn.email")}
                                        id="username"
                                        onChange={(event) => setUsername(event.target.value)}
                                    />
                                </Grid>
                                <Grid size={{xs: 12}}>
                                    <TextField
                                        error={error}
                                        sx={{background: "white"}}
                                        variant="standard"
                                        fullWidth
                                        label={t("signIn.password")}
                                        type="password"
                                        id="password"
                                        onChange={(event) => setPassword(event.target.value)}
                                    />
                                </Grid>

                            {errorMessage && (
                                <Typography color="error" sx={{marginTop: 2}}>
                                    {errorMessage}
                                </Typography>
                            )}

                        </Grid>
                    </CardContent>
                    <CardActions sx={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{marginTop: 2, backgroundColor: colors.primary[500], color: 'white'}}
                            onClick={async ()=> await handleLogin()}
                        >
                            {t("signIn.button")}
                        </Button>
                    </CardActions>
                </Card>
            </Box>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.modal + 1
                }}
                open={loading}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        </Container>
    );
};

export default SignInComponent;
